import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AccessControlService } from '../services/access-control.service';

export const userEditGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const accessControl = inject(AccessControlService);
  const router = inject(Router);
  const userId = route.paramMap.get('userId') ?? '';

  return accessControl
    .ensureLoaded()
    .pipe(
      map((loaded) =>
        loaded && accessControl.canEditUser(userId)
          ? true
          : router.createUrlTree(['/user-role-management'], { queryParams: { section: 'users' } }),
      ),
    );
};
